import { Component, Inject, OnInit } from "@angular/core";
import OktaAuth from "@okta/okta-auth-js";
import { OKTA_AUTH } from "@okta/okta-angular";
import { firstValueFrom } from "rxjs";
import { IvyModalOptions, IvyModalService } from '@crs/ivy';
import { UserIdleService } from 'angular-user-idle';

import { SessionTimeoutDialogComponent } from './common/session-timeout-dialog/session-timeout-dialog.component';
import { AppConfigService } from "./services/app-config.service";
import { FileOperationsLogoutService } from "./common/service/file-operations-logout.service";


@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    standalone: false
})
export class AppComponent implements OnInit {
	dialogOptions: IvyModalOptions = {
		allowCancel: false,
		size: 'md',
		backdrop: true,
	};

	constructor(
		@Inject(OKTA_AUTH) public oktaAuth: OktaAuth,
		private userIdle: UserIdleService,
		private modalService: IvyModalService,
		private appConfigService: AppConfigService,
	private readonly fileOperationsLogout: FileOperationsLogoutService
) {}

	ngOnInit() {
		//Start watching for user inactivity.
		this.userIdle.startWatching();
		// Start watching when user idle is starting.
		this.userIdle.onTimerStart().subscribe(count => count);
		// Start watch when time is up.
		this.userIdle.onTimeout().subscribe(() => {
			const ref = this.modalService.open(SessionTimeoutDialogComponent, this.dialogOptions);
			ref.result.then(
				async (r) => {
					if (r === 'yes') {
						this.restart();
						this.startWatching();
					} else {
						await firstValueFrom(this.fileOperationsLogout.revokeTokenBeforeLogout()).catch(() => {});
						await this.oktaAuth.signOut();
					}
				},
				() => {
					this.restart();
					this.startWatching();
				}
			);
			this.stopWatching();
		});

		this.startTokenRenewal();
	}

	stop() {
		this.userIdle.stopTimer();
	}

	stopWatching() {
		this.userIdle.stopWatching();
	}

	startWatching() {
		this.userIdle.startWatching();
	}

	restart() {
		this.userIdle.resetTimer();
	}

	startTokenRenewal() {
		const interval = 29 * 60 * 1000;

		setInterval(async () => {
			const isExpired = await this.appConfigService.isAccessTokenExpired();
			if (isExpired) {
				try {
					await this.appConfigService.renewAccessToken();
				} catch (error) {
					console.error(`Failed to renew access token:`, error);
				}
			}
		}, interval);
	}
}
